import { render, staticRenderFns } from "./SelectUploadType.vue?vue&type=template&id=484669de&scoped=true&"
import script from "./SelectUploadType.vue?vue&type=script&lang=js&"
export * from "./SelectUploadType.vue?vue&type=script&lang=js&"
import style0 from "./SelectUploadType.vue?vue&type=style&index=0&id=484669de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484669de",
  null
  
)

export default component.exports